import { CalendarCheck, CalendarClock } from "lucide-react";
import KpiCard from "shared/KpiCard";
import type { MeetingSummary } from "../api/MeetingsApi";
import { formatDaysAgo, formatMeetingDate } from "./meetingUtils";

/** Two KPI tiles for the current filter: how many meetings (and how many recent), and when the last one was. */
export default function SummaryStrip({ summary }: { summary: MeetingSummary | null }) {
  if (!summary) return null;
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
      <KpiCard
        label="Meetings"
        value={summary.meeting_count}
        hint={`${summary.recent_count} in the past 90 days`}
        icon={CalendarCheck}
      />
      <KpiCard
        label="Last meeting"
        value={<span className="text-2xl">{formatMeetingDate(summary.last_meeting_date)}</span>}
        hint={summary.last_meeting_date ? formatDaysAgo(summary.last_meeting_date) : "No meetings yet"}
        icon={CalendarClock}
      />
    </div>
  );
}
